import {initViewOnlyTimelineForm} from "../admin/projects/timeline/view-only-form.js";

function initCustomerTimelineShow() {
	/**
	 * @type {Timeline.FormSettings}
	 */
	let formSettings = {};

	// Check if we want to focus a given task
	const searchParams = (new URL(document.location)).searchParams;
	if (searchParams.has('task')) {
		formSettings.focusTask = searchParams.get('task');
	}

	initViewOnlyTimelineForm(document.querySelector('.timeline-form'), formSettings);

	/** Methods */


}

export {initCustomerTimelineShow}
